import { render, staticRenderFns } from "./CatalogsUpdate.vue?vue&type=template&id=018b4104&scoped=true"
import script from "./CatalogsUpdate.vue?vue&type=script&lang=ts"
export * from "./CatalogsUpdate.vue?vue&type=script&lang=ts"
import style0 from "./CatalogsUpdate.vue?vue&type=style&index=0&id=018b4104&prod&scoped=true&lang=css"
import style1 from "./CatalogsUpdate.vue?vue&type=style&index=1&id=018b4104&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b4104",
  null
  
)

export default component.exports